<template>
	<div id="editor">
		<div v-if="working" class="d-flex justify-content-center align-items-center" style="min-height:300px">
			<spinner size="huge" message="Updating..."></spinner>
		</div>
		<div v-if="!working">
			<form v-on:submit.prevent="transmitForm">
				<div class="container">
					<div class="head row">
						<div class="col col-sm-3" style="text-align:left">
							<i class="pseudobutton mdi mdi-arrow-right-bold-circle mdi-24px" @click="$emit('closeEditor')"><span style="">Back</span></i>
						</div>
						<div class="col col-sm-9">
							<h3>Edit Account <i>{{account.USR_LOGIN}}</i></h3>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_name">Name</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="s_name" v-model="account.USR_NAME" id="s_name"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">Login</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="s_login" v-model="account.USR_LOGIN" id="s_login"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_baseip">Email</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="s_email" v-model="account.USR_EMAIL" id="s_email"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">Neues Passwort</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="s_pwd" v-model="account.USR_PWD_NEW" id="s_pwd"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">Passwort wiederholen</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="s_pwd2" v-model="account.USR_PWD_NEW2" id="s_pwd2"/>
						</div>
					</div>
					<hr>
					<h3>Permissions</h3>
					<div v-for="perm in ACLS">
						<div class="form-group row">
							<label  class="col-sm-3 col-form-label" for="s_domain">{{ perm.ACL_NAME }}</label>
							<div class="col-sm-9">
								<b-form-radio-group id="btnradios1"
									buttons
									button-variant="outline-primary"
									size="sm"
									v-model="perm.ACL_HAS"
									:options="standardoptions"
									name="radiosBtnDefault" />
								</b-form-group>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col form-group" style="text-align:center">
							<button class="btn btn-success" type="submit">Change</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>
<script>
import Spinner from 'vue-simple-spinner'

export default {

	components: {
		Spinner
	},
	props: ['account', 'servers', 'working', 'standardoptions'],

	data() {
		return {
			renewclass: '',
			ACLS: []
		}
	},
	created: function() {
		let that = this
		this.$http.get("/account/acls", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}})
			.then(resp => {
				if(resp.data.error) {
					alert("Connection failed: " + resp.data.error)
				}
				else {
					that.ACLS = JSON.parse(JSON.stringify(resp.data))
					console.log(that.ACLS)
					this.loading = false;
				}
			})
			.catch(err => {
				alert(err)
				this.loading = false;
			})
	},
	methods: {
		transmitForm() {
			var formfields = [ 'USR_NAME', 'USR_LOGIN',
					'USR_EMAIL' ]
			let transfer = {}
			for(var i = 0;i < formfields.length;i++) {
				transfer[formfields[i]] = this.account[formfields[i]]
			}
			if(this.account.USR_PWD_NEW != '' && this.account.USR_PWD_NEW == this.account.USR_PWD_NEW2)
				transfer['USR_PWD'] = this.account.USR_PWD_NEW
			transfer['ACLS'] = this.ACLS
			this.$emit('insertItem', transfer)
		},
  }
}
</script>
